import { hooks as commonHooks } from '@sitebuilder/common';

export interface MonthSelectProps {
    selectedDate: Date;
    ariaLabel?: string;
    id?: string;
    onChange: (e: React.ChangeEvent<HTMLSelectElement>, key: string) => void;
}

const MonthSelect = (props: MonthSelectProps) => {
    const { selectedDate, ariaLabel, id, onChange } = props;
    const i18n = commonHooks.useLocalization();
    const locale = i18n.getLocale();
    return (
        <span className="date-select">
            <label htmlFor={id} className="sr-only">
                {ariaLabel}
            </label>
            <select
                className="start-date-month-input"
                onChange={(e) => onChange(e, 'month')}
                aria-label={ariaLabel || ''}
                id={id || ''}
                value={selectedDate?.getMonth()}
            >
                {[...Array(12)].map((_a, i: number) => (
                    <option key={i} value={i}>
                        {new Date(2021, i, 1).toLocaleDateString(locale, {
                            month: 'long',
                        })}
                    </option>
                ))}
            </select>
        </span>
    );
};

export default MonthSelect;
